import { useModuleConnectionStore } from '../stores/moduleConnection';

/**
 * Middleware для загрузки связанных модулей
 * Загружает данные о связях и сохраняет в store для использования в компонентах
 * 
 * @param {Array<string>} requiredConnections - массив типов модулей которые должны быть подключены
 * @param {Object} options - дополнительные опции
 * @returns {Function} middleware функция
 */
export default function moduleConnectionGuard(requiredConnections = [], options = {}) {
  const {
    redirectOnMissing = false,  // редиректить если нет связи (false = только загружаем данные)
    showToast = true             // показывать тост при ошибке
  } = options;

  return async function(to, from, next) {
    const connectionStore = useModuleConnectionStore();
    
    const moduleId = to.params.id || to.params.moduleId;
    
    if (!moduleId) {
      console.error('Module ID не указан в роуте');
      return next({ path: '/', query: { accessError: 'Не указан ID модуля' } });
    }
    
    // Загружаем связанные модули
    await connectionStore.loadConnections(moduleId);
    
    // Проверяем наличие требуемых связей И доступ к ним
    if (requiredConnections.length > 0 && redirectOnMissing) {
      for (const requiredType of requiredConnections) {
        const status = connectionStore.getConnectionStatus(moduleId, requiredType);
        
        // Проверяем что подключение существует И есть доступ
        if (!status.exists || !status.hasAccess) {
          if (showToast && window.$toast) {
            window.$toast.error(status.message);
          }
          
          // Редиректим на главную
          return next('/');
        }
      }
    }
    
    // Всё ОК - данные загружены в store, компоненты могут их использовать
    next();
  }
}

